import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, makeStyles, TextField, withStyles } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useTranslation } from 'react-i18next';
import { batchCreateSecondDelivery } from '../../../actions/utActions';
import { getUserPreference } from '../../../utilities/common';
import { showAlertSnackbar } from '../../../reducers/uiSlice';

const InputTextField = withStyles((theme) => ({
    root: {
        '& .MuiOutlinedInput-input': {
            padding: '10px !important',
        },
        width: 200,
        marginLeft: 5
    },
}))(TextField);

const useStyles = makeStyles((theme) => ({
    selectWidth: {
        width: 200
    }
}));

function SecondDelivery(props) {
    const dispatch = useDispatch();
    const {t} = useTranslation('updateToolbox');
    const classes = useStyles();
    const userPref = getUserPreference();

    const [subBatch, setSubBatch] = useState('');
    const [loading, setLoading] = useState(false);
    const [serviceNo, setServiceNo] = useState('');
    const [secondSubBatch, setSecondSubBatch] = useState('');
    const [updated, setUpdated] = useState(0);
    const [res, setRes] = useState(false);
    const [disabled, setDisabled] = useState(true);

    const handleServiceNo = (event) => {
        setServiceNo(event.target.value)
    }
    const handleSubBatch = (event) => {
        setSubBatch(event.target.value);
    };

    function handleSubmit() {
        setLoading(true);
        dispatch(batchCreateSecondDelivery(subBatch, userPref.userCity, serviceNo))
        .then((res) => {
            setSecondSubBatch(res.second_sub_batch);
            setUpdated(res.updated);
            setRes(true);
            dispatch(showAlertSnackbar({message: t('produce_success_message'), type: 'success'}))
            setLoading(false);
        })
        .catch(() => {
            dispatch(showAlertSnackbar({message: t('produce_fail_message'), type: 'error'}))
            setLoading(false);
        })
    }

    useEffect(() => {
        if(props.boxUpdate) {
            setSubBatch('');
            setRes(false);
        }
    }, [props.boxUpdate])
    useEffect(() => {
        if(subBatch && serviceNo) {
            setDisabled(false);
        } else {
            setDisabled(true);
        }
    }, [subBatch, serviceNo])

    return (
        <>
            <div 
                style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center'
                }}
            >
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <div>    
                        <span>{t('sub_batch')}</span>
                    </div>
                    <div>
                        <InputTextField
                            variant='outlined'
                            placeholder={t('input_batch')}
                            onChange={handleSubBatch}
                            value={subBatch}
                        />
                    </div>
                </div>
                <div style={{display: 'flex', alignItems: 'center', marginLeft: 30}}>    
                    <div>
                        <span>{t('service_no')}</span>
                    </div>
                    <div>
                        <InputTextField
                            variant='outlined'
                            placeholder={t('input_service')}
                            onChange={handleServiceNo}
                            value={serviceNo}
                        />
                    </div>
                </div>
                <div 
                    style={{ 
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginLeft: 30
                    }}
                >
                    <div style={{ display: 'flex'}}>
                        <Button
                            color="primary"
                            variant="contained"
                            component="span"
                            disabled={loading || disabled}
                            style={{ marginLeft: 10 }}
                            onClick={handleSubmit}
                        >
                            {t('confirm_lot_produce')}
                        </Button>
                        {
                            loading &&
                            <div className={classes.buttonStyle}>
                                <CircularProgress color='secondary'/>
                            </div>                   
                        }
                    </div>
                </div>
            </div>
            {
                res &&
                <div style={{marginTop:20}}>    
                    <div style={{display:'flex'}}>
                        <span>{t('second_sub_batch')}</span>
                        <span>{secondSubBatch}</span>
                    </div>
                    <div style={{display:'flex', marginTop:10}}>
                        <span>{t('updated')}</span>
                        <span>{updated}</span>
                    </div>
                </div>
            }   
        </>
    );
}

export default SecondDelivery;